// extracted by mini-css-extract-plugin
export default {"gameModeButton":"GameModeButton_gameModeButton__9yqlU","subtitle":"GameModeButton_subtitle__BvPsh"};